import About from "../../Components/About/About";
import Collections from "../../Components/Collections/Collections";

const tabs = [
  { id: 1, title: "About", content: <About /> },
  { id: 2, title: "Collections", content: <Collections /> },
];
export default tabs;
